/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react'
import { Redirect, Link } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import Required from './Required'
import { apiPostLogin } from '../../Apis'
import Version from '../../Version'
import Waiting from '../../Waiting'
import { useDetectedDevice, useWindowSize } from '../../WindowSize'
import { useTranslation } from 'react-i18next'
import i18n from '../../../../i18n'
import Separator from '../../Separator'
import imgLogo from '../../../../assets/img/logo.png'
import imgES from '../../../../assets/img/es.png'
import imgEN from '../../../../assets/img/en.png'
import {Footer} from '../../Footer'

/* ANTD */
import Button from 'antd/es/button'
import Input from 'antd/es/input'
import Alert from 'antd/es/alert'

/* ANTD MOBILE */
import NavBar from 'antd-mobile/es/nav-bar'
import Flex from 'antd-mobile/es/flex'
import WhiteSpace from 'antd-mobile/es/white-space'

import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'
import { connect } from 'react-redux'

const Login = (props) => {
  const [device] = useDetectedDevice()
  const [winSize] = useWindowSize()
  const [user, setUser] = useState(process.env.REACT_APP_USER_PRE)
  const [pwd, setPwd] = useState(process.env.REACT_APP_PWD_PRE)
  const [waiting, setWaiting] = useState(true)
  const [enableSend, SetEnableSend] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [recaptchaKey, setRecaptchaKey] = useState('')
  const refCaptcha = useRef('')
  const { t } = useTranslation()



  const handleLogin = () => {
    const newPost = {
      grant_type: 'password',
      userName: user,
      password: pwd,
      scope: process.env.REACT_APP_AUTH_CLIENT_SCOPE,
      client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET
    }
    setWaiting(true)
    const userPost = new URLSearchParams(newPost).toString()
    apiPostLogin('auth', 'connect/token', userPost, onSuccess, onError)
  }

  const onSuccess = (response, data, tag) => {
    setWaiting(false)
    props.loadLogin(response)
  }

  const onError = (response, data, tag) => {
    setWaiting(false)
    setErrorMessage(t('commonMessages.invalidUserPassword'))
    setPwd('')
    setRecaptchaKey(Date.now().toString())
    SetEnableSend(false)
  }

  const handleChangeData = (name, value) => {
    switch (name) {
      case 'user':
        setUser(value)
        break
      case 'pwd':
        setPwd(value)
        break
      default:
    }
  }

  const changeLanguage =(lng) =>{
    i18n.changeLanguage(lng)
  }

  const closeMessage = () => {
    setErrorMessage('')
  }

  const onChangeCaptcha = (value) => {
    SetEnableSend(true)
  }

  useEffect(() => {
    setWaiting(false)
    setRecaptchaKey(Date.now().toString())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (props.isUserAuthenticated) {
    return <Redirect to='/' />
  } 

  return (
    <div>
      <div className="element-header">
        <div className="container element-no-padding">
          <NavBar
            leftContent={
            <img 
            src={imgLogo} style={{height:60,width:210}}
            alt='' />
            }
            rightContent={
              <div>
                <img 
                  className={i18n.language === 'es' ? 'element-cursor-hand' : 'element-cursor-hand element-image-disabled'}
                  onClick={() => changeLanguage('es')}
                  src={imgES} 
                  alt=''  />
                &nbsp;
                <img 
                  className={i18n.language === 'en' ? 'element-cursor-hand' : 'element-cursor-hand element-image-disabled'}
                  onClick={() => changeLanguage('en')}
                  src={imgEN} 
                  alt='' 
                  />
              </div>
            }></NavBar>
          <Separator />
        </div>
      </div>
      <div className={device === 'browser' ? 'container' : ''}
        style={{ backgroundColor: 'white', height: (winSize[1] - 110), padding: '30px', overflowX: 'auto' }}>
        <div className="element-page-title">{t('commonMessages.welcome')}</div>
        <WhiteSpace size="lg" />
        <WhiteSpace size="lg" />
        <Flex>
          <Flex.Item>
            <div><label className='element-form-label'>{t('common.user')}</label></div>
            <Input placeholder='' style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} maxLength={250}
              onChange={e => handleChangeData('user', e.target.value)}
              value={user} />
            <Required required={!user} />
          </Flex.Item>
        </Flex>
        <WhiteSpace size="sm" />
        <Flex>
          <Flex.Item>
            <div><label className='element-form-label'>{t('common.password')}</label></div>
            <Input.Password placeholder='' style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} maxLength={250}
              onChange={e => handleChangeData('pwd', e.target.value)}
              value={pwd} />
            <Required required={!pwd} />
            {
              errorMessage !== '' && (
                <div>
                  <WhiteSpace size="lg" />
                  <Alert message={errorMessage} closable afterClose={closeMessage} type="error" style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} />
                </div>
              )
            }
          </Flex.Item>
        </Flex>

        <WhiteSpace size="lg" />
        <Flex>
          <Flex.Item>
            <Link to="/forgot">{t('commonMessages.forgotPassword')}</Link>
          </Flex.Item>
        </Flex>

        <WhiteSpace size="lg" />
        <Flex>
          <Flex.Item>
            {recaptchaKey &&
              <ReCAPTCHA
                onChange={onChangeCaptcha}
                key={'rc' + recaptchaKey}
                ref={refCaptcha}
                hl={'es'}
                sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              />
            }
          </Flex.Item>
        </Flex>

        <WhiteSpace size="lg" />
        <WhiteSpace size="lg" />
        <Flex justify={device === 'phone' ? 'center' : 'start'}>
          <Button disabled={enableSend === false} onClick={handleLogin} type="primary" shape="round" icon="check" >
            {t('common.login')}
          </Button>
        </Flex>
        <WhiteSpace size="lg" />
        <WhiteSpace size="lg" />
      </div>
      <Version />
      <Footer />
      <Waiting show={waiting} />
      {recaptchaKey && <div style={{ color: 'white' }}>=={recaptchaKey}</div>}
    </div>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    loadLogin: (response) => dispatch({ type: 'LOGIN', payload: response })
  }
}

const mapStateToProps = state => ({
  isUserAuthenticated: state.LoginReducer.isAuthenticated,
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
